<template>
    <div class="xydt">
        <div class="w1200 bt">
            <h3>科研动态</h3>
            <span>NEWS INFORMATION</span>
            <img src="@/assets/img/ico-t.png" alt="">
        </div>
        <ul class="xydtBox">
            <li
        v-for="(item, index) in xydtList"
        :key="item.ID"
        @mouseenter="hoverRoll(item)"
        class="wow fadeInLeft"
        :data-wow-delay="index / 5 + 's'"
      >
        <router-link
          :to="item.Url"
          :href="item.Url"
          @click.native="OpenLink(item.Url)"
        >
                    <img :src="item.Cover" alt="">
                    <div class="xydt_title">
                        <div class="xydt_text">
                            <h3>{{ item.Title }}</h3>
                            <p>{{ item.Describe }}</p>
                        </div>
                        <div class="xydt_time">
                            <p>{{ setTimeformat(item.ShowTime, "dd") }}</p>
                            <span>{{ setTimeformat(item.ShowTime, "yyyy-mm") }}</span>
                        </div>
                    </div>
                </router-link>
            </li>
        </ul>
        <div class="more">
            <router-link :to="moreLink">
                <p>查看更多></p>
            </router-link>
        </div>
    </div>
</template>
<script>
export default {
  name: "xydt",
  props: {
    xydtList: {
      // 图片列表
      type: Array,
      default: () => [],
    },
    moreLink: {
      type: String,
      default: "",
    },
    styles: {
      type: Object,
      default: () => {
        return {
          width: 1920,
          height: 500,
        };
      },
    },
  },
  data() {
    return {
      showItem: this.dataList ? this.dataList[0] : null,
    };
  },
  methods: {
    setTimeformat(_data, _format = "yyyy-mm-dd") {
      return _format
        .replace(/YYYY/i, _data.substr(0, 4))
        .replace(/MM/i, _data.substr(5, 2))
        .replace(/DD/i, _data.substr(8, 2));
    },
    hoverRoll(_data) {
      this.showItem = _data;
    },
  },
};
</script>
<style lang="less" scoped >
.xydt {
  width: 1200px;
  height: auto;
  margin-top: 50px;
  margin-bottom: 50px;
  .bt{
  width: 1200px;
  text-align: center;
  margin-bottom: 50px;
    h3{
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 2px;
    color: #32454f;
    margin-bottom: 5px;
    }
    span{
      display: block;
      font-size: 16px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #32454f;
      padding-bottom: 5px;
    }
    img{
      display: block;
      object-fit: cover;
      margin: 0 auto;
      width: 214px;
      height: 14px;
    }
  }
  .xydtBox{
    height: 440px;
    li{
      &:hover{
        .xydt_title{
          box-shadow: -9px 0px 32px 0px 
          rgba(0, 0, 0, 0.05);
          background-color: #ffffff;
          .xydt_text h3{
            color: #0376be;
          }
        }
      } 
      .xydt_title{
        width: 600px;
        height: 110px;
        margin: 0;
        display: flex;
        flex-wrap: nowrap;
        .xydt_text{
          width: 405px;
          padding-top: 18px;
          margin: 0 auto;
          box-sizing: border-box;
          h3{
            width: 405px;
            text-overflow:ellipsis;
            white-space:nowrap;
            overflow:hidden;
            margin: 0;
            font-size: 18px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 20px;
            letter-spacing: 2px;
            color: #333333;
            margin-bottom: 8px;
          }
           p{
            text-overflow: ellipsis;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 2px;
            color: #666666;
          }
        }
        .xydt_time{
          width: 135px;
          margin: 0;
          height: 71px;
          margin-top: 18px;
          border-left: solid 1px #d9d9d9;
          box-sizing: border-box;
          p{
            font-size: 34px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 40px;
            letter-spacing: 3px;
            color: #999999;
            text-align: center;
          }
          span{
            display: block;
            font-size: 16px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 26px;
            letter-spacing: 2px;
            color: #999999;
            text-align: center;
          }
        }
      }
      img{
        display: none;
      }
      &:first-child{
      float: left;
      width: 560px;
      margin-right: 40px;
      img{
        display: block;
        width: 560px;
        height: 327px;
        object-fit: cover;
      }
      .xydt_title{
      width: 100%;
      height: 114px;
      display: flex;
      flex-wrap: nowrap;
      padding-top: 18px;
      box-sizing: border-box;
      .xydt_text{
        width: 385px;
        padding-top: 0px;
        h3{
          width: 100%;
          margin: 0;
          text-overflow:ellipsis;
          white-space:nowrap;
          overflow:hidden;
          font-size: 18px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 20px;
          letter-spacing: 2px;
          color: #333333;
          margin-bottom: 8px;
        }
        p{
          font-size: 16px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 2px;
          color: #666666;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
    .xydt_time{
      margin-top: 0px;
    }
    }
    }
  }
  .more{
    width: 150px;
    height: 50px;
    border-radius: 5px;
    margin: 0 auto;
    border: solid 1px #0376be;
    box-sizing: border-box;
    margin-top: 40px;
    padding: 0;
    a{
    display: block;
      p{
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 50px;
      letter-spacing: 2px;
      color: #0376be;
      text-align: center;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/xydt.vue